import { render, staticRenderFns } from "./shoplazzaList.vue?vue&type=template&id=1bf15082"
import script from "./shoplazzaList.vue?vue&type=script&lang=js"
export * from "./shoplazzaList.vue?vue&type=script&lang=js"
import style0 from "./shoplazzaList.vue?vue&type=style&index=0&id=1bf15082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports